// components/Landing.js
import React from "react";
import { Button } from "../ui/button"; // Import UI components
import { Card } from "../ui/card";

const Landing = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <div className="w-full bg-gradient-to-b from-black to-[#353535] p-8">
        <h1 className="text-white text-4xl font-bold text-center">
          Video Consent System
        </h1>
      </div>

      {/* Main Content */}
      <div className="max-w-3xl mx-auto p-6 space-y-8 mt-8">
        {/* Info Card */}
        <Card className="bg-white p-8 rounded-xl shadow-lg">
          <h2 className="text-2xl font-semibold mb-4">How it works</h2>

          <div className="space-y-6">
            {/* Steps */}
            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 rounded-full bg-black text-white flex items-center justify-center flex-shrink-0">
                1
              </div>
              <div>
                <h3 className="font-medium text-lg">
                  Generate Verification Link
                </h3>
                <p className="text-gray-600">
                  Start by getting your verification link from our Telegram bot
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 rounded-full bg-black text-white flex items-center justify-center flex-shrink-0">
                2
              </div>
              <div>
                <h3 className="font-medium text-lg">Enter Your Details</h3>
                <p className="text-gray-600">
                  Fill in your information using the verification link
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 rounded-full bg-black text-white flex items-center justify-center flex-shrink-0">
                3
              </div>
              <div>
                <h3 className="font-medium text-lg">Record Your Consent</h3>
                <p className="text-gray-600">
                  Record a short video reading the provided script
                </p>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="mt-8 space-y-4">
            <Button
              onClick={() =>
                window.open("https://t.me/behookedai_bot", "_blank")
              }
              className="w-full h-12 bg-gradient-to-b from-black to-[#353535] text-white rounded-full"
            >
              Open Telegram Bot
            </Button>

            <p className="text-center text-gray-500">
              Already requested a link? Check your Telegram messages or wait a
              few minutes.
            </p>
          </div>
        </Card>

        {/* FAQ Section */}
        <Card className="bg-white p-8 rounded-xl shadow-lg">
          <h2 className="text-2xl font-semibold mb-4">
            Frequently Asked Questions
          </h2>

          <div className="space-y-4">
            <div>
              <h3 className="font-medium text-lg">How long does it take?</h3>
              <p className="text-gray-600">
                The entire process typically takes less than 5 minutes to
                complete.
              </p>
            </div>

            <div>
              <h3 className="font-medium text-lg">What do I need?</h3>
              <p className="text-gray-600">
                You'll need a device with a camera, microphone, and an active
                Telegram account.
              </p>
            </div>

            {/* Add more FAQs as needed */}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Landing;
